import { ChainId_Internal } from '../types';
export const SMART_ROUTER_ENDPOINT_BY_CHAIN = {
    [ChainId_Internal.ZK_EVM]: 'https://public-api.vvs.finance/api/v1/quote',
    [ChainId_Internal.ZK_EVM_TEST]: 'https://testnet-public-api.vvs.finance/api/v1/quote',
    [ChainId_Internal.CRONOS_EVM_MAINNET]: 'https://public-api.vvs.finance/api/v1/quote',
    [ChainId_Internal.CRONOS_EVM_TESTNET]: 'https://testnet-public-api.vvs.finance/api/v1/quote',
    [ChainId_Internal.ETHEREUM]: 'https://public-api.vvs.finance/api/v1/quote',
    [ChainId_Internal.SEPOLIA]: 'https://testnet-public-api.vvs.finance/api/v1/quote',
};
// for price api
export const FARM_ENDPOINT_BY_CHAIN = {
    [ChainId_Internal.ZK_EVM]: 'https://api.h2.finance/general/api/v1/farms',
    [ChainId_Internal.ZK_EVM_TEST]: 'https://psta-h2-api.crorc.co/api/internal/v1/farms',
    [ChainId_Internal.CRONOS_EVM_MAINNET]: 'https://api.vvs.finance/general/api/v1/farms',
    [ChainId_Internal.CRONOS_EVM_TESTNET]: 'https://psta-vvs-api.crorc.co/api/internal/v1/farms',
    [ChainId_Internal.ETHEREUM]: '',
    [ChainId_Internal.SEPOLIA]: '',
};
// for price api
export const WHITELIST_TOKENS_ENDPOINT_BY_CHAIN = {
    [ChainId_Internal.ZK_EVM]: 'https://api.h2.finance/general/api/v1/whitelist-tokens',
    [ChainId_Internal.ZK_EVM_TEST]: 'https://psta-h2-api.crorc.co/api/internal/v1/whitelist-tokens',
    [ChainId_Internal.CRONOS_EVM_MAINNET]: 'https://api.vvs.finance/general/api/v1/whitelist-tokens',
    [ChainId_Internal.CRONOS_EVM_TESTNET]: 'https://psta-vvs-api.crorc.co/api/internal/v1/whitelist-tokens',
    [ChainId_Internal.ETHEREUM]: '',
    [ChainId_Internal.SEPOLIA]: '',
};
